var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product"},[_c('ul',_vm._l((_vm.urls),function(url,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":'/news/'+url.id}},[_c('img',{attrs:{"src":url.thumb}})])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }